import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
    const isAuthenticated = !!sessionStorage.getItem('accessToken');
    
    if (!isAuthenticated) {
        return <Navigate to="/" />;
    }
    
    return children;
};

export default ProtectedRoute;